import { useExamContext } from "@features/exam/contexts/ExamContext";
import { isWeb } from "@helpers/platform";
import { useAppStore } from "@hooks/useAppStore";
import { useMemo } from "react";
import { buildBottomTabs } from "./helpers";

export const useBottomTabs = () => {
	const navigationRoutes = useAppStore((store) => store.navigation.routes.main);
	const showStudyPackAsHome = useAppStore((store) => store.showStudyPackAsHome);
	const practiceTestEnabled = useAppStore(
		(store) => store.exam.practiceTest.enabled,
	);

	const {
		currentExamContext: { practiceTestProductNumericId },
	} = useExamContext();

	return useMemo(
		() =>
			buildBottomTabs({
				navigationRoutes,
				showStudyPackAsHome: !!showStudyPackAsHome,
				practiceTestProductNumericId,
				practiceTestEnabled,
				isWebPlatform: isWeb,
			}),
		[
			navigationRoutes,
			showStudyPackAsHome,
			practiceTestProductNumericId,
			practiceTestEnabled,
		],
	);
};
